<template>
  <div class="container">
    <div class="header">
      <img src="@/assets/erjian/top_bg.jpg" alt="" />
      <h1>二级建造师报考信息查询平台</h1>
    </div>
    <div class="nav-container">
      <div class="w1200">
        <div class="nav-tabs">
          <ul>
            <li :class="{ on: currentNavTab == index }" v-for="(item, index) in navTabs" :key="index" @click="tabClick(index)">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w1200">
      <span class="red-hint">在校生、及中专以下学历不能报考</span>
      <section class="tab-content">
        <component :is="navTabs[currentNavTab].comp"></component>
      </section>
    </div>
    <div class="school">济南梓学教育咨询有限公司长春分公司</div>
  </div>
</template>
<script>
import TabComp0 from './components/tabComp0.vue'
import TabComp1 from './components/tabComp1.vue'
import TabComp2 from './components/tabComp2.vue'
import TabComp3 from './components/tabComp3.vue'
import TabComp4 from './components/tabComp4.vue'
export default {
  data() {
    return {
      currentNavTab: 0,
      navTabs: [
        { name: '报考条件', comp: 'TabComp0', id: 'tag1' },
        { name: '报名时间', comp: 'TabComp1', id: 'tag2' },
        { name: '考试时间', comp: 'TabComp2', id: 'tag3' },
        { name: '考试科目', comp: 'TabComp3', id: 'tag4' },
        { name: '专业对照表', comp: 'TabComp4', id: 'tag5' }
      ]
    }
  },
  components: {
    TabComp0,
    TabComp1,
    TabComp2,
    TabComp3,
    TabComp4
  },
  watch: {
    $route(to, from) {
      this.currentNavTab = this.navTabs.findIndex(item => item.id == this.$route.params.id) || 0
    }
  },

  methods: {
    tabClick(index) {
      this.$router.push(`/erjian/${this.navTabs[index].id}`)
    }
  },
  created() {
    if (!this.$route.params.id) {
      this.currentNavTab = 0
      return
    }
    this.currentNavTab = this.navTabs.findIndex(item => item.id == this.$route.params.id) || 0
  },
  mounted() {
    window._agl = window._agl || []
    window._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD'])
    const agl = document.createElement('script')
    agl.type = 'text/javascript'
    agl.async = true
    agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD'
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(agl, s)
  },
  metaInfo() {
    return {
      title: `二级建造师考试信息网`
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 160px;
    img {
      width: 100%;
      height: 160px;
      position: absolute;
      z-index: 0;
      object-fit: cover;
      top: 0;
      left: 0;
      right: 0;
      vertical-align: bottom;
    }
    h1 {
      color: #fff;
      font-size: 50px;
      font-weight: bold;
      z-index: 1;
    }
  }

  .nav-container {
    background: rgb(241, 241, 241);
  }
  .nav-tabs {
    position: relative;

    margin-top: -1px;
    z-index: 9;
    ul {
      display: flex;
      align-items: center;
      padding: 0 50px;
      li {
        flex: 1;
        text-align: center;
        line-height: 40px;
        height: 40px;
        color: #000;
        font-size: 18px;
        cursor: pointer;
        &.on {
          color: #fff;
          background: rgb(16, 68, 138);
        }
      }
    }
  }
  .red-hint {
    display: block;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 15px;
    font-size: 18px;
    color: #d51719;
  }
  .tab-content {
    width: 950px;
    margin: 0 auto;
    padding-bottom: 50px;

    border: 1px solid rgb(231, 231, 231);
  }
  .school {
    font-size: 14px;
    color: #666;
    margin: 20px 0;
    text-align: center;
  }
}
</style>
